import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import FilterChip from './FilterChip';

const FilterChipContainerStyled = styled.div`
  position: absolute;
  left: ${({ chipScrollOffset }) => chipScrollOffset}px;
  top: 50%;
  transform: translateY(-50%);
  transition-duration: ${({ scrollDuration }) =>
    scrollDuration ? scrollDuration : 1.0}s;
  transition-property: left;
  white-space: nowrap;
  padding-top:3px;
`;

class FilterChipContainer extends React.PureComponent {
  static propTypes = {
    chipScrollOffset: PropTypes.number,
    filters: PropTypes.arrayOf(PropTypes.object).isRequired,
    filterStyles: PropTypes.object,
    filterChipStyles: PropTypes.object,
    getContainerComponent: PropTypes.func.isRequired,
    handleChipClick: PropTypes.func.isRequired,
    scrollDuration: PropTypes.number,
  };

  static defaultProps = {  
    chipScrollOffset: 0,
    filterStyles: {},
    filterChipStyles: undefined,
    scrollDuration: null,
  };

  getContainerComponentref = element => {
    if (!element) {
      return null;
    }

    this.element = element;
    this.props.getContainerComponent(element);
    const {getContainerComponent } = this.props;
    const filterCount =  this.props.filters; 
    var setIntervalForChildren = window.setInterval(function () {
      if(element.childElementCount > 0) {
        window.clearInterval(setIntervalForChildren);
        getContainerComponent(element);
      }
     }, 1000);

    return element;
  };

  renderFilters = () => {
    const filters = this.props.filters.filter(filter => filter.id !== 'search').map(filter => {
      const { id, styles, title, isSelected } = filter;
      return (
        <FilterChip
          selectedCallback={this.props.handleChipClick}
          filterChipStyles={this.props.filterChipStyles}
          id={id}
          key={id}
          styles={styles}
          title={title}
          isSelected={isSelected}
          filterStyles={this.props.filterStyles}
        />
      );
    });

    return filters;
  };

  render() {
    return (
      <FilterChipContainerStyled
        chipScrollOffset={this.props.chipScrollOffset}
        filterChipStyles={this.props.filterChipStyles}
        ref={this.getContainerComponentref}
        scrollDuration={this.props.scrollDuration}
      >
        {this.renderFilters()}
      </FilterChipContainerStyled>
    );
  }
}

export default FilterChipContainer;
